import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "republish-pdf-content"
    }}>{`Republish PDF Content`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Content originally published in PDF documents can be repurposed to extend its reach and impact, as well as the content owner’s ability to monetize it. Making content available in new, alternative media or translating it to one or more different languages are just two examples of how PDF content might be republished. When republishing PDF documents, it is essential that key contextual attributes of the original content are captured and carried forward in order to preserve and retain the document’s original true meaning. Document structure, reading order, fonts and text styling, text semantics (i.e., tagging a block of text as a paragraph, heading, or list), and the associated images that reinforce meaning are all critical to the republishing process. Adobe PDF Extract API empowers content owners to republish PDF documents to any number of alternative formats and media to extend its value.`}</p>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-extract.md"
        }}>{`Adobe PDF Extract API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`A company wants to make a certain type of information normally published in PDF available in audio format using text-to-speech technology. Making written documents available in audio form creates a flexible and convenient way for people to consume information and can also enable interactive experiences for consuming tables, figures, and images.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this solution`}</h3>
    <ol>
      <li parentName="ol">{`Pass a PDF to Adobe PDF Extract API to retrieve text content`}</li>
      <li parentName="ol">{`Extract headings and paragraph text from the JSON parsed content`}</li>
      <li parentName="ol">{`Use a Text to Speech API (TTS) to create an audio version of the text including a heading index for voice navigation`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      